var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExhibitionContainer',{attrs:{"ble-id":_vm.label_id,"asset-id":_vm.asset_id,"token":_vm.t,"form-id":_vm.hubspotIds.formId,"portal-id":_vm.hubspotIds.portalId,"region":_vm.hubspotIds.region}},[_c('template',{slot:"banner"},[_c('Banner',{attrs:{"booth-number":"Building ABC, Level 1 - C14492"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }